import { api } from './api';

export interface LanguageOption { code: string; name: string; english: string; }

export const languageApi = {
  options: () => api.get<LanguageOption[]>('/api/me/language/options'),
  get: () => api.get<{ code: string }>('/api/me/language/'),
  set: (code: string) => api.put<{ code: string }>('/api/me/language/', { code }),
};
